import GET_ARTICLES from "../class/getArticles";
import Swiper from "swiper/bundle";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import { Pagination, Navigation, Scrollbar, Autoplay } from 'swiper/modules';
Swiper.use([Pagination, Navigation, Scrollbar, Autoplay]);

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];

const domReady = TPL => {
  new BLOCKS;
};

class BLOCKS{
  constructor() {
    this.mainvisual();
    this.news();
    this.works();
    this.parallax();
  }

  // メインビジュアル
  mainvisual () {
    let Mv = document.querySelector('.mainvisual');
    window.addEventListener('load', function() {
      if (Mv) Mv.classList.add('loaded'); 
    });

    try {
      news_ticker.render();
    } catch (e) {
      console.warn("news_tickerの読み込みに失敗、または未定義です:", e);
    }
  }

  // ニュース4件表示
  news() {
    const getArticle = new GET_ARTICLES('.block-news__list');
    getArticle.makeItem = (item) => {
      return `
      <li class="block-news__item">
        <a href="${item.href}" class="block-news__link">
          <figure class="thumb">
            <img src="${item.thumb}" alt="${item.title}" width="100%" loading="lazy">
          </figure>
          <div class="text_wrap">
            <span class="date">${item.date}</span>
            <span class="cate">${item.category.name}</span>
            <p class="ttl${(item.is_new) ? ' is-new' : ''}"><span>${item.title}</span></p>
          </div> 
          <img class="arrow" src="/assets/svg/icon_arrow.svg" alt="矢印">
        </a>
      </li>`;
    };
    getArticle.render();

    const categoryContainer = d.querySelectorAll('.block-news [data-plugin="getCategories"]');
    
    categoryContainer.forEach(obj => {
      let contentParam = obj.getAttribute('data-content') || 'news';
      
      contentParam = contentParam.replace(/[\(\)\{\}\$]/g, '').split('.').pop() || 'news';
      
      if (contentParam.includes('MODULE_TITLE')) {
        contentParam = 'news';
      }

      this.fetchCategories(contentParam).then(res => {
        console.log("APIから取得したカテゴリデータ:", res);

        let catsArray = [];
        if (Array.isArray(res)) {
          catsArray = res;
        } else if (res && Array.isArray(res.data)) {
          catsArray = res.data;
        } else if (res && typeof res === 'object') {
          catsArray = Object.values(res);
        }

        const catAll = {
          id: 'all', href: '/news/?mode=list', name: 'ALL', turn: 0
        };
        
        const allCats = [catAll, ...catsArray];
        
        const makeHTML = catItem => {
          const id = catItem.id || catItem.term_id || 'default';
          const href = catItem.href || `/news/?cate=${id}`;
          const name = catItem.name || catItem.title || '';
          return `<li class="block-news__tag-item"><a class="block-news__tag-link is-${id}" href="${href}">${name}</a></li>`;
        };
        
        obj.innerHTML = '';
        allCats.forEach(catItem => obj.insertAdjacentHTML('beforeend', makeHTML(catItem)));
        
      }).catch(err => {
        console.error("カテゴリのデータ取得に失敗しました:", err);
      });
    });
  }

  fetchCategories (content) {
    return fetch(`/assets/api/getCategories/?content=${content}`)
      .then(r => r.json())
      .catch(e => { throw new Error(e)});
  }

  // 製品実績
  works () {
    const getArticle = new GET_ARTICLES('.works_list .swiper-wrapper');
    
    let count = 0;

    getArticle.makeItem = (item) => {
      if (count >= 10) return '';
      count++; 

      return `
      <div class="swiper-slide">
        <a href="${item.href}" class="c-card-works">
          <figure class="c-card-works__img">
            <img src="${item.thumb}" alt="${item.title}" width="100%" loading="lazy">
          </figure>
          <div class="c-card-works__body">
            <p class="cat"><span>${item.category.name}</span></p>
            <p class="ttl"><span>${item.title}</span></p>
          </div>
        </a>
      </div>`;
    };

    count = 0;

    getArticle.render().then(() => {
      const sliderElement = document.querySelector('.works_list');
      
      if(sliderElement){ 
        const worksSlide = new Swiper(sliderElement, {
          speed: 500,
          slidesPerView: 'auto', 
          spaceBetween: 20, 
          
          breakpoints: {
            768: {
              spaceBetween: 55 
            }
          },
          
          simulateTouch: true,
          watchSlidesProgress: true,
          loop: true,
          observer: true,
          observeParents: true,
          
          navigation: {
            nextEl: sliderElement.querySelector('.works-next'),
            prevEl: sliderElement.querySelector('.works-prev')
          },
          pagination: {
            el: sliderElement.querySelector('.works-pagination'),
            type: 'progressbar',
            clickable: true
          }
        });
      }
    });
  }


  parallax() {
    const parallaxContainers = d.querySelectorAll('.js-parallax-container');
    if (parallaxContainers.length === 0) return;

    let mm = gsap.matchMedia();

    mm.add("(min-width: 901px)", () => {
      
      parallaxContainers.forEach((container) => {
        const img = container.querySelector('.js-parallax-img');
        if (!img) return;

        const speed = img.getAttribute('data-speed') || '20%';

        gsap.fromTo(img, 
          {
            yPercent: parseFloat(speed)
          },
          {
            yPercent: -parseFloat(speed),
            ease: 'none',
            scrollTrigger: {
              trigger: container,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1
            }
          }
        );
      });

    });
  }


}

const jqInit = () => false;

export default function HOME () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', jqInit);
  } else {
    jqInit();
  }
}